import { Card, Switch, Form } from 'antd'
import { FacebookIcon, InstagramIcon, LinkedInIcon, TikTokIcon, XIcon, YouTubeIcon } from '../platformIcons/Social_Icons'


const ShareSettingsCard = () => (
  <Card title="Choose where to share" className="share-settings-card">
    <div className="share-list">
      <ShareRow name={['sharingOptions', 'facebook']} icon={<FacebookIcon />} text="Facebook" cls="facebook" />
      <ShareRow name={['sharingOptions', 'instagram']} icon={<InstagramIcon />} text="Instagram" cls="instagram" />
      <ShareRow name={['sharingOptions', 'tiktok']} icon={<TikTokIcon />} text="TikTok" cls="tiktok" />
      <ShareRow name={['sharingOptions', 'X']} icon={<XIcon />} text="X" cls="x" />
      <ShareRow name={['sharingOptions', 'youtube']} icon={<YouTubeIcon />} text="YouTube" cls="youtube" />
      <ShareRow name={['sharingOptions', 'linkedIn']} icon={<LinkedInIcon />} text="LinkedIn" cls="linkedin" />
    </div>
  </Card>
)

const ShareRow = ({ name, icon, text, cls }: {
  name: (string | number)[]
  icon: React.ReactNode
  text: string
  cls: string
}) => (
  <div className="share-item">
    <div className="share-left">
      <div className={`icon ${cls}`}>{icon}</div>
      <span>Share on {text}</span>
    </div>
    <Form.Item
      name={name}
      valuePropName="checked"
      initialValue={false}
      style={{ margin: 0 }}
    >
      <Switch />
    </Form.Item>
  </div>
)

export default ShareSettingsCard
